export enum UserOsTypes {
   WINDOWS = 'WINDOWS',
   MAC = 'MAC',
   IOS = 'IOS',
   ANDROID = 'ANDROID',
   UNKNOWN = 'UNKNOWN',
}

export const mObywatelLinksBasedOnUserOS = {
   [UserOsTypes.WINDOWS]: 'https://info.mobywatel.gov.pl',
   [UserOsTypes.MAC]: 'https://info.mobywatel.gov.pl',
   [UserOsTypes.IOS]: 'https://apps.apple.com/pl/app/mobywatel/id1339613469',
   [UserOsTypes.ANDROID]: 'https://play.google.com/store/apps/details?id=pl.nask.mobywatel',
}


/**
 * Funkcja zwracająca odpowiedni link do google play bądź app store
 * bazując na systemie operacyjnym użytkownika
 *
 * @returns {String | undefined} 
*/
export const getAppLinkBasedOnOS = (): string | undefined => {
   const userAgent = navigator.userAgent
   
   if (/windows/i.test(userAgent)) { // Windows
       return mObywatelLinksBasedOnUserOS[UserOsTypes.WINDOWS]
   }
   else if (/macintosh|mac os x/i.test(userAgent)) { // MacOS
       return mObywatelLinksBasedOnUserOS[UserOsTypes.MAC]
   }
   else if (/iPad|iPhone|iPod/.test(userAgent) && !('MSStream' in window)) { // iOS
       return  mObywatelLinksBasedOnUserOS[UserOsTypes.IOS]
   }
   else if (/android/i.test(userAgent)) { // Android
       return  mObywatelLinksBasedOnUserOS[UserOsTypes.ANDROID]
   }

   return undefined
}